<template>
  <v-form
    :data="form"
    method="patch"
    :url="$laravel.route('api.account.update')"
    @success="next()"
  >
    <v-account-information />
    <d-card-row class="pt-0">
      <div class="is-flex is-justify-content-flex-end">
        <button class="button is-primary">
          <span>{{ $t('next') }}</span>
          <span class="icon">
            <i class="mdi mdi-arrow-right" />
          </span>
        </button>
      </div>
    </d-card-row>
  </v-form>
</template>

<script>

import masks from "@/services/masks";
import informationVue from "@/shared/views/account/fieldsets/information.vue";
import { fillFields } from "@/services/helpers";
import Step from "./step";

export default {
  components: {
    "v-account-information": informationVue
  },
  extends: Step,
  data () {
    return {
      form: {
        address_1: "",
        address_2: "",
        city: "",
        state: null,
        country: "ca",
        postal_code: "",
        phone: "",
        phone_extension: "",
        cell_phone: "",
        birthday: null,
        _scenarios: [Registration.scenario]
      },
      masks: masks
    };
  },
  created () {
    this.form = fillFields(this.form, this.$laravel.user);
  }
};
</script>
